import { render, staticRenderFns } from "./MindSetPage.vue?vue&type=template&id=1e6145d6&"
import script from "./MindSetPage.vue?vue&type=script&lang=js&"
export * from "./MindSetPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports